import { useEffect, useState } from 'react'

import { PSApplication } from '../app/PSApplication'
import Button from '../app/design/Button'
import Modal from '../app/design/Modal'
import { Chip } from '../common/fields/Chip'
import { Select } from '../common/fields/Select'
import { WorkflowPage } from '../workflows/WorkflowPage'
import { SelectOption, findSelection, gratuityPercentOptions } from './Options'
import { gratuityOptions } from './Options'

type Props = {
    isOpen: boolean
    onClose: () => void
    onDone: (gratuity: string | undefined, gratuityPercentage: string | undefined) => void
}

export function SetupGratuityModal({ isOpen, onClose, onDone }: Props) {
    const user = PSApplication.me()
    const [isDropdownOpen, setIsDropdownOpen] = useState<string | undefined>(undefined)

    const findGratuitySelection = (user: any) =>
        findSelection(gratuityOptions, user.requestGratuity)

    const findPercentSelection = (user: any) => findSelection(gratuityPercentOptions, user.gratuity)

    const [gratuity, setGratuity] = useState<SelectOption | undefined>(
        findGratuitySelection(user) ?? gratuityOptions[0]
    )
    const [suggestedPercentage, setSuggestedPercentage] = useState<SelectOption | undefined>(
        findPercentSelection(user)
    )

    const hasEdits = true

    useEffect(() => {
        setGratuity(findGratuitySelection(user))
        setSuggestedPercentage(findPercentSelection(user))
    }, [user])

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Gratuity"
            footer={
                <Button
                    intent="primary"
                    onClick={() => onDone(gratuity?.value, suggestedPercentage?.value)}
                    disabled={!hasEdits}
                >
                    Save
                </Button>
            }
        >
            <div className="flex flex-col gap-8">
                <WorkflowPage.IconSection title="Request gratuity" icon="settings.large">
                    <div className="flex flex-wrap gap-2">
                        {gratuityOptions.map((option) => (
                            <Chip
                                size="small"
                                key={option.value}
                                title={option.label}
                                isSelected={gratuity?.value === option.value}
                                onClick={() => setGratuity(option)}
                            />
                        ))}
                    </div>
                </WorkflowPage.IconSection>

                <WorkflowPage.IconSection title="Suggested gratuity" icon="dollar.large">
                    <Select
                        size="medium"
                        options={gratuityPercentOptions.map((option) => ({
                            id: option.value,
                            title: option.label,
                            selectOption: option,
                        }))}
                        selectedOptionID={suggestedPercentage?.value}
                        onSelectOption={(option) => setSuggestedPercentage(option.selectOption)}
                    />
                </WorkflowPage.IconSection>
            </div>
        </Modal>
    )
}
